export default __webpack_public_path__ + "static/media/mr_mrs_smith_s1.36f672cf.png";